<div class="text-center align-items-center">
  <h1 class="mb-3 mx-auto">Bitácora</h1>
</div>

<div class="d-flex justify-content-end gap-2 mb-3 mx-3">
  <button mat-raised-button class="text-danger" routerLink="">
    Salir
  </button>
  <button mat-raised-button class="text-primary" (click)="enviarLog()">
    Enviar bitácora
  </button>
</div>

<span *ngFor="let log of logs" [ngStyle]="estilos">
  <p>{{ log }}</p>
</span>
